import { Skeleton } from "@/components/shared/Skeleton";

export function RosterRowSkeleton() {
  return (
    <li className="py-3 space-y-1.5">
      <Skeleton className="h-5 w-40" />
      <Skeleton className="h-3 w-24" />
    </li>
  );
}
